module.exports = __webpack_public_path__ + "static/img/cop_sch_logo6.f4ba8fc6.png";